import {useField} from "formik";

const formatDateTyping = (value) => {
  const digits = String(value || "").replace(/\D/g, "").slice(0, 8);
  return [digits.slice(0, 2), digits.slice(2, 4), digits.slice(4, 8)]
    .filter(Boolean)
    .join("/");
};

const formatTimeTyping = (value) => {
  const digits = String(value || "").replace(/\D/g, "").slice(0, 4);
  return [digits.slice(0, 2), digits.slice(2, 4)].filter(Boolean).join(":");
};

const DateTimeField = ({
  name,
  kind,
  className = "",
  "aria-required": ariaRequired,
}) => {
  const [field, , helpers] = useField(name);
  const isDate = kind === "date";
  const formatter = isDate ? formatDateTyping : formatTimeTyping;

  return (
    <div className="relative flex-1 min-w-[160px]">
      <input
        {...field}
        type="text"
        inputMode="numeric"
        autoComplete="off"
        maxLength={isDate ? 10 : 5}
        placeholder={isDate ? "jj/mm/aaaa" : "hh:mm"}
        aria-required={ariaRequired}
        className={`w-full !pr-10 ${className}`}
        onChange={(event) => helpers.setValue(formatter(event.target.value))}
      />
      <i
        aria-hidden="true"
        className={`${
          isDate ? "fi fi-rr-calendar" : "fi fi-rr-clock-three"
        } pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 flex items-center text-[#19295C]`}
      />
    </div>
  );
};

export const FrenchDateField = (props) => (
  <DateTimeField {...props} kind="date" />
);

export const FrenchTimeField = (props) => (
  <DateTimeField {...props} kind="time" />
);
